import React from "react";
import OrdenActiva from "../activas/orden_activa";

const OrdenFinalizada = () => {
  return <OrdenActiva mode="finalizadas" />;
};

export default OrdenFinalizada;
